import React, { Children, cloneElement, PropTypes } from 'react';

const { node, object } = PropTypes;

const DashboardRow = ({ children, style, titleStyle }) => {
  const requiredStyles = {
    verticalAlign: 'top',
    display: 'inline-block',
    width: `calc(100%/${children.length || 1})`,
  };

  const rowStyle = Object.assign({}, { paddingBottom: '15px', paddingRight: '10px' }, style, requiredStyles);

  const rowContent = Children.map(children, (child, key) => {
    return (
        <div style={rowStyle}>
          <h3
            style={Object.assign({}, {
              fontSize: '16px',
              fontWeight: '300',
              margin: 0,
              padding: 0,
              textAlign: key % 2 === 0 ? 'left' : 'right',
            }, titleStyle)}
          >
            {child.props.title}
          </h3>
          { cloneElement(child, { key }) }
        </div>
    );
  });

  return (
    <div>
      {rowContent}
    </div>
  );
};

DashboardRow.propTypes = {
  children: node.isRequired,
  style: object,
};

export default DashboardRow;



// WEBPACK FOOTER //
// ./src/app/components/dashboard/DashboardRow.jsx